<template>
  <div>
    <div style="height:60px" class="hidden-md-and-up"></div>
    <h2>REQUISITOS PARA EL REGISTRO</h2>
    <v-layout row wrap align-center>
      <v-flex x10 sm6 xs12>
        <Requisito :titulo="abogado.titulo" subheader="" :requisitos="abogado.requisitos" />
        <v-flex sm15>
          <Requisito subheader="" :requisitos="abogado.notas" />
        </v-flex>
      </v-flex>
      <v-flex x10 sm6 xs12>
        <v-flex sm15>
          <v-img :src="require('@/assets/registro_abogado.jpg')" ></v-img>
        </v-flex>
        
      </v-flex>

      <v-flex sm6>
        <v-img :src="require('@/assets/sociedad_civil.jpg')"></v-img>
      </v-flex>
      <v-flex sm6>
        <Requisito :requisitos="sociedad.requisitos" :titulo="sociedad.titulo" subheader="Requisitos" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Requisito from "@/components/Registro/Requisito";
export default {
  components: {
    Requisito
  },
  data() {
    return {
      abogado: {
        titulo: "Nuevo Abogado",
        requisitos: [
          {
            icon: "fingerprint",
            iconClass: "lime white--text",
            title: "El solicitante debe contar con Ciudadanía Digital",
            subtitle:
              "Presiona aqui para registrarte <a href='https://www.gob.bo/ciudadania/registrate' target='_blank' >www.gob.bo/ciudadania</a>",
          },
          {
            icon: "language",
            iconClass: "blue white--text",
            title: "Ingresar al Sistema de Registro de la Abogacía (SRA)",
            subtitle:
              "Presiona aqui para ingresar <a href='https://sra.justicia.gob.bo' target='_blank' >sra.justicia.gob.bo</a> ingresa a la opción <b>“Registro de Abogado”</b>",
          },
          {
            icon: "format_list_numbered",
            iconClass: "indigo white--text left",
            title: "Llena el formulario de registro, para esto debes tener",
            subtitle:
              "<ul><li>Fotografía digital 3x3 en fondo blanco, actualizada, clara, de frente y sin lentes, en formato JPG, no debe ser mayor a 1 MB</li><li>Firma en color azul y fondo blanco en formato JPG, no debe ser mayor a 1 MB</li><li>En un solo documento tener escaneado su Cédula de Identidad, Título Profesional original a color (anverso y reverso) y el NIT (opcional) todo en formato PDF</li></ul>"
          },
          {
            icon: "thumb_up",
            iconClass: "pink white--text rigth",
            title: "Confirmar el formulario de solicitud de registro en el SRA a través de Ciudadanía Digital",
            subtitle: null
          },
          {
            icon: "monetization_on",
            iconClass: "green wite--text",
            title: "Pago del importe de la solicitud, por un total de Bs400,00 a través de nuestros dos métodos de pago: por QR desde cualquier banco  o CPT solo por el Banco Unión.",
            subtitle: null
          },
          
        ],

        notas: [
          {
            icon: "warning",
            iconClass: "yellow black--text",
            title: "¡Importante!",
            subtitle: "El recojo de la credencial es personal o con Poder Notarial Específico.",
          }
        ]
      },
      sociedad: {
        titulo: "Sociedades Civiles",
        requisitos: [
          {
            icon: "fingerprint",
            iconClass: "lime white--text",
            title: "El solicitante debe contar con Ciudadanía Digital",
            subtitle:
              "Presiona aqui para registrarte <a href='https://www.gob.bo/ciudadania/registrate' target='_blank' >www.gob.bo/ciudadania</a>",
          },
          {
            icon: "language",
            iconClass: "blue white--text",
            title: "Ingresar al Sistema de Registro de la Abogacía (SRA)",
            subtitle:
              "Presiona aquí para ingresar <a href='https://sra.justicia.gob.bo' target='_blank' >sra.justicia.gob.bo</a> ingresa a la opción <b>“Sociedades Civiles”</b>",
          },
          {
            icon: "format_list_numbered",
            iconClass: "indigo white--text",
            title: "Llena el formulario de registro, para esto debes tener",
            subtitle:
              "<ul><li>Acta o escritura de constitución que describa la estructura interna en formato PDF</li><li>Reglamento y procedimientos internos en formato PDF</li><li>Documento que acredite la designación del representante legal en formato PDF</li></ul>"
          },
          {
            icon: "thumb_up",
            iconClass: "pink white--text",
            title: "Confirmar el formulario de solicitud de registro en el SRA a través de Ciudadanía Digital",
            subtitle: null
          },
          {
            icon: "monetization_on",
            iconClass: "green wite--text",
            title: "Pago del importe de la solicitud, por un total de Bs500,00 a través de nuestros dos métodos de pago: por QR desde cualquier banco  o CPT solo por el Banco Unión.",
            subtitle: null
          }
        ]
      }
    };
  },
  mounted: function () {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Registro/Registro.vue